exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-tabs-items[data-v-0e0eac39] {\n  background-color: #F4F5F7;\n}\n.v-label[data-v-0e0eac39] {\n  padding-left: 5px !important;\n}\n.v-application .red--text[data-v-0e0eac39] {\n  margin-top: 10px !important;\n}\n", ""]);

// exports
